import './switchCompany.css'

class SwitchCompanyController {
  /* @ngInject */

  constructor ($mdDialog, $mdToast, company, companyList) {
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.company = company
    this.companyList = companyList
    this.selectedCompany = this.company.internal_id
    this.searchCompanyText = ''
  }

  closeDialog () {
    this.$mdDialog.cancel()
  }

  selectCompany () {
    this.$mdDialog.hide(this.selectedCompany)
  }
}

export default SwitchCompanyController
